/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditCacheCounters {
    getFixupPrototypeFunction() { return RequestAuditCacheCounters.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditCacheCounters>): RequestAuditCacheCounters {
        let obj = Object.assign(new RequestAuditCacheCounters(), model);
        RequestAuditCacheCounters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditCacheCounters>): RequestAuditCacheCounters {
        if (!model) return null;
        return RequestAuditCacheCounters.newInstance(<RequestAuditCacheCounters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditCacheCounters) {
        if (!obj) return;

        models.RequestAuditCacheCounters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditCacheCounters): boolean {
        Object.setPrototypeOf(obj, RequestAuditCacheCounters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.hits) {
            models.RequestAuditPerformanceCounter.fixupPrototype(this.hits);
        }
        if (this.misses) {
            models.RequestAuditPerformanceCounter.fixupPrototype(this.misses);
        }
        if (this.invalidations) {
            models.RequestAuditPerformanceCounter.fixupPrototype(this.invalidations);
        }
    }

    /**
     * Counter for cache hits.
     */
    hits: models.RequestAuditPerformanceCounter;

    /**
     * Counter for cache misses.
     */
    misses: models.RequestAuditPerformanceCounter;

    /**
     * Counter for cache invalidations.
     */
    invalidations: models.RequestAuditPerformanceCounter;

}
